import * as React from "react";

interface ErlButtonBigProps {
    label: string,
    onclick?: (callback: any) => void,
    disabled: boolean,
    type?: 'submit' | 'reset' | 'button',
    inactive?: boolean,
    className?: string,
}

/**
 * Großer grüner Button
 */
export class ErlButtonBigRed extends React.Component<ErlButtonBigProps, {}> {

    public static defaultProps = {
        label: 'Label',
        disabled: false,
        height: 'normal',
        type: 'button',
        className: 'avia-button avia-icon_select-no avia-color-dark avia-size-medium alternate-color',
    };

    render() {
        let classNames = this.props.className;

        if (this.props.inactive) {
            classNames += ' inactive';
        }

        return <button onClick={this.props.onclick} disabled={this.props.disabled} type={this.props.type} className={classNames}>
            {this.props.label}{this.props.children}
        </button>
    }
}